import { useEffect } from 'react'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'

export default function TermsOfService() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-slate-900">
            <Header />

            {/* Letter Container */}
            <div className="max-w-4xl mx-auto px-4 py-12">
                {/* Paper-like Document */}
                <div className="bg-white dark:bg-slate-800 shadow-2xl" style={{
                    boxShadow: '0 0 0 1px rgba(0,0,0,0.05), 0 10px 50px rgba(0,0,0,0.15)'
                }}>

                    {/* Letterhead */}
                    <div className="border-b-4 border-purple-600 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 px-12 py-8">
                        <div className="text-center">
                            <h1 className="text-3xl font-serif font-bold text-gray-900 dark:text-white mb-2">
                                SUDHA'S ACADEMY
                            </h1>
                            <p className="text-sm text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                                Online Learning Platform for Makeup & Beauty Education
                            </p>
                        </div>
                    </div>

                    {/* Document Body */}
                    <div className="px-12 py-10">

                        {/* Document Title */}
                        <div className="text-center mb-8 pb-6 border-b-2 border-gray-200 dark:border-gray-700">
                            <h2 className="text-2xl font-serif font-bold text-gray-900 dark:text-white mb-2">
                                TERMS OF SERVICE
                            </h2>
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Effective Date: December 5, 2025
                            </p>
                        </div>

                        {/* Letter Content */}
                        <div className="prose prose-sm max-w-none dark:prose-invert">

                            {/* Introduction */}
                            <div className="mb-8">
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    <strong>Welcome to Sudha's Academy!</strong>
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    These Terms of Service ("Terms") constitute a binding contract between you and Sudha's Academy ("we", "us", "our"). By accessing or using our Platform, creating an account, or enrolling in a course, you agree to be bound by these Terms.
                                </p>
                            </div>

                            {/* Section 1 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    1. Accounts
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    You need an account for most activities on our platform. Keep your password safe, because you’re responsible for all activity associated with your account. If you suspect someone else is using your account, let us know by contacting our support team. You must have reached the age of consent for online services in your country to use Sudha's Academy.
                                </p>
                            </div>

                            {/* Section 2 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    2. Course Enrollment and Lifetime Access
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    When you enroll in a course, you get a license from us to view it via the Sudha's Academy Services and no other use. Don’t try to transfer or resell courses in any way. We grant you a lifetime access license, except when we must disable the course because of legal or policy reasons.
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    <strong>Important for Beauty Students:</strong> Enrollment in our courses does not constitute a professional license to practice cosmetology or makeup artistry in your jurisdiction. It is your responsibility to check local laws regarding professional licensing requirements.
                                </p>
                            </div>

                            {/* Section 3 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    3. Payments, Credits, and Refunds
                                </h3>
                                <h4 className="text-base font-semibold text-gray-800 dark:text-gray-200 mb-2">
                                    3.1 Pricing
                                </h4>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    The prices of courses are determined based on the terms of the instructor and our promotional policies. In some instances, the price of a course offered on the Sudha's Academy website may not be exactly the same as the price offered on our mobile or TV applications, due to mobile platform pricing systems.
                                </p>
                                <h4 className="text-base font-semibold text-gray-800 dark:text-gray-200 mb-2">
                                    3.2 Refunds
                                </h4>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    If the course you purchased is not what you were expecting, you can request, within 7 days of your purchase of the course, that Sudha's Academy apply a refund to your account. We reserve the right to apply your refund as a refund credit or a refund to your original payment method, at our discretion. No refund is due to you if you request it after the 7-day guarantee time limit has passed.
                                </p>
                            </div>

                            {/* Section 4 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    4. Content and Behavior Rules
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    You may not access or use the Services or create an account for unlawful purposes. Your use of the Services and behavior on our platform must comply with applicable local or national laws or regulations of your country. You are solely responsible for the knowledge of and compliance with such laws and regulations that are applicable to you.
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    <strong>Live Sessions Code of Conduct:</strong> During live video sessions, you must maintain professional and respectful behavior. Harassment, hate speech, or inappropriate conduct will result in immediate removal from the session and potential account suspension.
                                </p>
                            </div>

                            {/* Section 5 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    5. Health and Safety Disclaimer
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    <strong>Read Carefully:</strong> The courses offered on Sudha's Academy involve practical beauty and makeup techniques. By practicing these techniques, you acknowledge that there are inherent risks involved, including but not limited to skin irritation, allergic reactions, or accidental injury from tools.
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    You agree that Sudha's Academy and its instructors are not liable for any injuries, damages, or losses resulting from your practice of techniques learned on our platform. You are responsible for patch testing products and using tools safely.
                                </p>
                            </div>

                            {/* Section 6 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    6. Sudha's Academy Rights
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    We own the Sudha's Academy platform and Services, including the website, present or future apps and services, and things like our logos, API, code, and content created by our employees. You can’t tamper with those or use them without authorization.
                                </p>
                            </div>

                            {/* Section 7 */}
                            <div className="mb-8">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    7. Miscellaneous Legal Terms
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    These Terms are like any other contract, and they have important legal terms that protect us from the countless things that could happen and clarify the legal relationship between us and you.
                                </p>
                                <h4 className="text-base font-semibold text-gray-800 dark:text-gray-200 mb-2">
                                    7.1 Binding Agreement
                                </h4>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    You agree that by registering, accessing, or using our Services, you are agreeing to enter into a legally binding contract with Sudha's Academy. If you do not agree to these Terms, do not register, access, or otherwise use any of our Services.
                                </p>
                                <h4 className="text-base font-semibold text-gray-800 dark:text-gray-200 mb-2">
                                    7.2 Governing Law and Jurisdiction
                                </h4>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    These Terms are governed by the laws of India. Any dispute arising out of or relating to these Terms will be subject to the exclusive jurisdiction of the courts in [Your City/State], India.
                                </p>
                            </div>

                            {/* Closing */}
                            <div className="mb-8 pt-6 border-t-2 border-gray-200 dark:border-gray-700">
                                <h3 className="text-lg font-serif font-bold text-gray-900 dark:text-white mb-4 uppercase">
                                    Contact Us
                                </h3>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4 text-justify">
                                    The best way to get in touch with us is to contact our Support Team. We’d love to hear your questions, concerns, and feedback about our Services.
                                </p>
                                <div className="bg-gray-50 dark:bg-slate-700 p-4 rounded border-l-4 border-purple-600 mb-6">
                                    <p className="text-gray-700 dark:text-gray-300 mb-1">
                                        <strong>Email:</strong> hello@sudhasacademy.com
                                    </p>
                                </div>
                                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2">
                                    Sincerely,
                                </p>
                                <p className="text-gray-900 dark:text-white font-semibold text-lg">
                                    The Sudha's Academy Team
                                </p>
                            </div>

                        </div>
                    </div>

                    {/* Footer */}
                    <div className="border-t-2 border-gray-200 dark:border-gray-700 px-12 py-6 bg-gray-50 dark:bg-slate-900">
                        <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
                            This document is a legally binding agreement between you and Sudha's Academy.
                            Please read it carefully and keep a copy for your records.
                        </p>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    )
}
